import React, { useState } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";

const Header = () => {
	const [isOpen, setOpen] = useState(false);

	const handleIsOpen = () => {
		setOpen(!isOpen);
	};

	const closeSideBar = () => {
		setOpen(false);
	};

	return (
		<TotalNavigation>
			<StyledHeader>
				<nav>
					<NavLink to={"/#works"}>Works</NavLink>
					<NavLink to={"/"} className="ek">
						<span className="ekene">EKENE</span>
						<span className="dot">.</span>
					</NavLink>
					<NavLink to={"/about"} className="about">
						About me
					</NavLink>
				</nav>
			</StyledHeader>
			<div className="mobile-nav">
				<StyledMobileHeader>
					<NavLink to={"/about"} className="about">
						About me
					</NavLink>
					<NavLink to={"/"} className="ek">
						<span className="ekene">EKENE</span>
						<span className="dot">.</span>
					</NavLink>
					<NavLink to={"/about"} className="placeholder">
						<img src="./images/Menu.svg" alt="" />
					</NavLink>
				</StyledMobileHeader>
				<Menu
					right
					customBurgerIcon={<img src="./images/Menu.svg" alt="" />}
					customCrossIcon={
						<img src="./images/icon-close.svg" alt="" />
					}
					isOpen={isOpen}
					onOpen={handleIsOpen}
					onClose={handleIsOpen}
				>
					<StyledNavList>
						<NavLink
							id="home"
							className="menu-item"
							to={"/product"}
							onClick={closeSideBar}
						>
							Product
						</NavLink>

						<NavLink
							id="about"
							className="menu-item"
							to={"/branding"}
							onClick={closeSideBar}
						>
							Branding
						</NavLink>
						<NavLink
							id="contact"
							className="menu-item"
							to={"/motion"}
							onClick={closeSideBar}
						>
							Interactive And Motion Design
						</NavLink>
						<NavLink
							id="contact"
							className="menu-item"
							to={"/product"}
							onClick={closeSideBar}
						>
							Product Design
						</NavLink>
						<NavLink
							id="contact"
							className="menu-item"
							to={"/illustrations"}
							onClick={closeSideBar}
						>
							Illustrations
						</NavLink>
					</StyledNavList>
				</Menu>
			</div>
		</TotalNavigation>
	);
};

export default Header;

const TotalNavigation = styled.div`
	.desk-nav {
		display: none;
	}
	@media (min-width: 900px) {
		.desk-nav {
			display: fixed;
		}
		.mobile-nav {
			opacity: 0;
		}
	}
`;
const StyledNavList = styled.div`
	display: flex !important;
	flex-direction: column;
	margin-top: 120px;
	gap: 32px;
	a {
		text-decoration: none;
		color: black;
	}
`;

const StyledMobileHeader = styled.header`
	@media (min-width: 900px) {
		display: none;
	}
	box-shadow: rgb(133 162 197) 0px 1px 49px -12px;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	background-color: white;
	padding: 32px 0;
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: space-around;
	.placeholder {
		opacity: 0;
	}
	a {
		text-decoration: none;
		color: inherit;
	}

	.ekene {
		font-weight: 700;
		font-size: 1.2rem;
	}
	.ek {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 1;
		width: max-content;
	}

	.dot {
		color: rgba(157, 0, 212, 1);
		font-size: 1.5rem;
	}
`;
const StyledHeader = styled.header`
	box-shadow: 0px -6px 49px rgba(133, 162, 197, 0.2);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 3;
	background-color: white;
	.ek {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 1;
	}
	.ekene {
		font-weight: 800;
		font-size: 1.5rem;
		font-family: AxiformaBlack;
	}
	.dot {
		color: rgba(157, 0, 212, 1);
		font-size: 1.5rem;
	}
	.about {
		justify-self: end;
	}
	nav {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		padding: 36px 48px;
		max-width: 800px;
		margin: 0 auto;
		a {
			text-decoration: none;
			color: inherit;
		}

		@media (min-width: 1000px) {
			max-width: 1300px;
		}
	}
`;
